// extracted by mini-css-extract-plugin
module.exports = {"Picture":"_3leBU","Placeholder":"_1WHdS"};